import { PM } from '@kulee/helper'
import Ad from './Ad'
import GameBase from './GameBase'
import logger from './logger'
import PKGame from './PKGame'
import Rank from './Rank'
import UC from './UC'
import { applyInstanceMixins } from './utils'
import Wallet from './Wallet'

import type { Context, GameInfo, SDKI } from './types'

class SDK implements SDKI {
  public __version = '__VERSION__'

  // 游戏数据初始化回调
  public onGameInit = () => {
    logger.warn('onGameInit is not implemented')
    tgaGameSDK.gameReady()
  }

  // 游戏开始事件回调
  public onGameStart = () => {
    logger.warn('onGameStart is not implemented')
  }

  // 游戏暂停
  public onGamePause = () => {
    logger.warn('onGamePause is not implemented')
  }

  // 游戏恢复
  public onGameResume = () => {
    logger.warn('onGameResume is not implemented')
  }

  // 对战中收到游戏数据事件回调
  public onReceiveGameMessage = () => {
    logger.warn('onReceiveGameMessage is not implemented')
  }

  // 对战中收到玩家退出事件回调
  public onPlayerExit = () => {
    logger.warn('onPlayerExit is not implemented')
  }

  // ----内部使用----
  public __game!: GameInfo

  public __setGame = (game: GameInfo) => {
    this.__game = game
  }

  // ----内部使用----
  // ----只是定义，实现由Ad模块注入----
  public initAd = () => Promise.resolve(true)

  public showPrerollAd = () => {}
  // ----只是定义，实现由Ad模块注入----
}

const sdk = new SDK()

const context: Context = {
  pm: new PM({
    target: window.parent
  }),
  sdk
}

// const ad = new Ad(context)
// try {
//   ad.init()
// } catch (error) {
//   logger.error('ad init error', error)
// }

const tgaGameSDK = applyInstanceMixins(sdk, [
  new GameBase(context),
  new Ad(context),
  new UC(context),
  new Rank(context),
  new Wallet(context),
  new PKGame(context)
])

export default tgaGameSDK
